/**
 *@author       罗朝军
 *@date         2021/10/13 14:50
 *@Copyright    天源迪科信息技术股份有限公司
 *@Description
 */
import { scpQryBidEvaProcessStatusApi } from "@/app/sourcingFlow/api/scp-expertEvaluation.js";

export default {
  data() {
    return {};
  },
  created() {
    this.qryBidEvaProcessStatus();
  },
  mounted() {},
  methods: {
    qryBidEvaProcessStatus() {
      let joinId = JSON.parse(sessionStorage.getItem("expertSourceData"))
        .joinExpertId;
      if (
        this.$router.history.current.query.evaPurStep === "801" ||
        this.$router.history.current.query.evaPurStep === "802"
      ) {
        joinId = sessionStorage.getItem("joinId");
      }
      let purStep =
        this.$router.history.current.name ===
          "subSupplierComplianceInspection" ||
        this.$router.history.current.name === "subSupplierComplianceConfirm"
          ? "0804"
          : this.$router.history.current.query.menuKey;
      if (
        this.$router.history.current.name === "businessBidDetailConfirm" ||
        this.$router.history.current.name === "businessBidDetailEdit"
      ) {
        purStep = "0811";
      }
      scpQryBidEvaProcessStatusApi({
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId,
        joinExpertId: joinId,
        purStep,
        evaPurStep: this.$router.history.current.query.evaPurStep
      }).then(res => {
        sessionStorage.setItem(
          "bidEvaProcessStatus",
          JSON.stringify(res.data.data)
        );
      });
    }
  }
};
